export default __webpack_public_path__ + "static/media/istirahat.e7d7b95e.png";